
<template>
  <v-speed-dial
    v-model="btnVisibility"
    :openOnHover="openOnHover"
    :direction="direction"
    :transition="transition"
    :top="top"
    :bottom="bottom"
    :right="right"
    :left="left"
  >
    <template v-slot:activator>
      <v-btn v-model="btnVisibility" :color="color" dark :fab="btnC">
        <v-icon v-if="btnVisibility"> mdi-close </v-icon>
        <v-icon v-else> {{ iconDefault }}</v-icon>
      </v-btn>
    </template>
    <v-btn
      v-for="btn in this.btnDesignIcon"
      :key="btn.id"
      :color="btn.btnColor"
      :fab="iconC"
      dark
      small
      @click="emit(btn.action + '-click', params)"
    >
      <v-icon :color="btn.iconColor">{{ btn.icon }}</v-icon>
    </v-btn>
  </v-speed-dial>
</template>

<script>
import emittable from "../../mixins/emittable";

import {
  VSpeedDial,
  VBtn,
  VIcon
} from 'vuetify/lib'

export default {
  name: "MenuFlash",
  components: {
    VSpeedDial,
    VBtn,
    VIcon
  },
  props: {
    btnC: {
      type: Boolean,
      default: false,
    },
    iconC: {
      type: Boolean,
      default: true,
    },

    top: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
    left: {
      type: Boolean,
      default: false,
    },
    iconDefault: {
      type: String,
      default: "mdi-account-circle",
    },
    color: {
      type: String,
      default: "primary",
    },
    direction: {
      type: String,
      default: "right",
    },
    transition: {
      type: String,
      default: "slide-y-reverse-transition",
    },
    openOnHover: {
      type: Boolean,
      default: false,
    },
    btnDesignIcon: {
      type: Object,
      default: function () {
        return {
          add: {
            id: 0,
            title: "Add",
            icon: "mdi-plus",
            btnColor: "teal darken1",
            iconColor: "white",
            action: "add",
          },
          delete: {
            id: 1,
            title: "Remove",
            icon: "mdi-delete",
            btnColor: "teal darken2",
            iconColor: "white",
            action: "delete",
          },
          edit: {
            id: 2,
            title: "Edit",
            icon: "mdi-pencil",
            btnColor: "teal darken3",
            iconColor: "white",
            action: "edit",
          },
        };
      },
    },
  },
  mixins: [emittable],

  data: () => ({
    btnVisibility: false,
    params: [],
  }),

  computed: {},

  watch: {},
};
</script>

<style>
#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}
</style>